import ReactDOM from "react-dom";

const pinCloudPortalRoot = document.getElementsByClassName('restaurants-map')[0];

export const PinCloudPortal = props => {
  const {
    children
  } = props;

  return ReactDOM.createPortal(children, pinCloudPortalRoot);
}
